import { render, staticRenderFns } from "./SmartFiltersList.vue?vue&type=template&id=28f6bd18&scoped=true&"
import script from "./SmartFiltersList.vue?vue&type=script&lang=js&"
export * from "./SmartFiltersList.vue?vue&type=script&lang=js&"
import style0 from "./SmartFiltersList.vue?vue&type=style&index=0&id=28f6bd18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f6bd18",
  null
  
)

export default component.exports